"use client"

import { type ColumnDef } from "@tanstack/react-table"

import { Table } from "@shared/ui"

import { UserActivity } from "../../types"

const columns: ColumnDef<UserActivity>[] = [
    {
        accessorKey: "activity",
        header: "Activity",
        cell: ({ row }) => <div>{row.getValue("activity")}</div>,
    },
    {
        accessorKey: "username",
        header: "User",
        cell: ({ row }) => <div>{row.getValue("username")}</div>,
    },
    {
        accessorKey: "date",
        header: "Date",
        cell: ({ row }) => <div>{row.getValue("date")}</div>,
    },
]

interface ActivityTimelineTableProps {
  activityTimeline: UserActivity[]
}

export const ActivityTimelineTable = ({
    activityTimeline,
}: ActivityTimelineTableProps) => {
  return <Table data={activityTimeline} columns={columns} />
}
